<template lang="pug">
  v-card(
    v-if="loaded"
    elevated)
    v-card-content
      v-switch.mb-3(
        :label="'base.auto_load' | translate"
        v-model="form.auto_load")
      v-switch(
        :label="'base.ignore_in_reports' | translate"
        v-model="form.ignored_in_report")
</template>

<script>
import api from '@/api'

import { mapActions } from 'vuex'

export default {
  name: 'RationItemInfoDialog',

  props: {
    item: Object
  },

  mounted () {
    this.loadData()
  },

  beforeDestroy () {
    this.update()
  },

  data: () => ({
    form: {
      farm: 0,
      name: '',
      auto_load: false,
      ignored_in_report: false
    },
    loaded: false
  }),

  methods: {
    ...mapActions('ingredients', [
      'selectIngredient'
    ]),

    async loadData () {
      const res = await this.selectIngredient(this.item.ingredient)
      this.form.farm = res.farm
      this.form.name = res.name
      this.form.auto_load = res.auto_load
      this.form.ignored_in_report = res.ignored_in_report
      this.loaded = true
    },

    update () {
      const payload = {
        ...this.form
      }
      api.ingredients.updateById(this.item.ingredient, payload)
    }
  }
}
</script>
